<template>
    <div class="test-allow-replay-users-table fixed-with-overflow-y small-scrollbar">
        <test-page-header
            :title="trans.edit_form.not_allow_replay_users_label"
            :is-one-line-title="false"
            :return-button="returnButton"
        />
        <div class="fixed-with-overflow-y small-scrollbar">
            <table class="table is-fullwidth">
                <thead>
                    <tr>
                        <th>{{ trans.edit_form.not_allow_replay_users_table.name }}</th>
                        <th>{{ trans.edit_form.not_allow_replay_users_table.date }}</th>
                        <th>{{ trans.edit_form.not_allow_replay_users_table.allow }}</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="(item, id) in users" :key="id">
                    <td>{{item.name}}</td>
                    <td>{{ formatDatetime(item.date) }}</td>
                    <td>
                        <button class="button is-small allow-user-to-replay-button">
                            <span class="icon" @click.stop="unblockRepeatHandler(item)">
                              <i class="fas fa-check"></i>
                            </span>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TestPageHeader from "../TestPageHeader";

export default {
    name: "TestUserListRepeatBlock",
    components: {TestPageHeader},
    props: {
    },
    data() {
        return {
            userHandled: null,
        }
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testEditor',
        ]),
        users() {
            return this.testEditor.notAllowReplayUsers;
        },
        returnButton() {
            return {
                text: 'К настройке теста',
                handler: this.backToEditTest,
            }
        },
    },
    created() {
        this.loadNotAllowReplayUsers(this.testEditor.test);
    },
    methods: {
        ...mapActions('tests', [
            'backToEditTest',
            'allowUserToTestReplay',
            'loadNotAllowReplayUsers',
            'showAllowUserToReplayConfirmationModal',
            'hideConfirmationModal',
        ]),
        transHeader(key) {
            return key;
        },
        unblockRepeatHandler(user) {
            let text = this.trans.edit_form.modals.allow_user_replay_text;
            this.userHandled = user;

            this.showAllowUserToReplayConfirmationModal(
                {
                    text: this.replaceWildcards(text, {
                        'user_name': user.name,
                    }),
                    confirmationHandler: this.unblockUserReplay,
                    cancelHandler: this.hideModalHandler,
                }
            );
        },

        unblockUserReplay() {
            this.allowUserToTestReplay(
                {
                    test: this.testEditor.test,
                    email: this.userHandled.email,
                }
            );

            this.hideModalHandler();
        },
        hideModalHandler() {
            this.userHandled = null;
            this.hideConfirmationModal();
        },
        formatDatetime(timestamp) {
            let d = new Date(timestamp * 1000);

            return ('0' + d.getDate()).slice(-2)
                + '.' + ('0' + (d.getMonth() + 1)).slice(-2)
                + '.' + d.getFullYear()
                + ' ' + ('0' + d.getHours()).slice(-2)
                + ':' + ('0' + d.getMinutes()).slice(-2);
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../../../../sass/variables';

.bulma .test-allow-replay-users-table {
    .table {
        font-size: 1rem;

        .allow-user-to-replay-button {
            &:hover {
                color: $tests-blue;
            }
        }

        th,td {
            vertical-align: middle;
            text-align: center;
        }

        tr td,th{

            .icon {
                cursor: pointer;
            }

            &:first-child {
                text-align: left;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 300px;
            }

            &:last-child {
                max-width: 150px;
                width: 150px;
            }
        }
    }
}

</style>